import React, { Fragment } from "react";
import Login from "./../user/Login";
import LoginHome from "./LoginHome";
import { Helmet } from "react-helmet";

const HomeLayout = (props) => {
  //   const configContext = useContext(ConfigContext);
  //   const alertContext = useContext(AlertContext);
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Add cash value to your registered METRO Q® Fare Card or METRO Day Pass using a credit card or debit card. The process is quick and easy. Log in here."
        />
      </Helmet>
      <div className="sidebar">
        <Login />
      </div>
      <div className="main-content" ref={props.mainContentRef} tabIndex="-1">
        <LoginHome appTitle={props.appTitle} />
      </div>
    </Fragment>
  );
};

export default HomeLayout;
